const A11YFIX_IFRAME_READY_MESSAGE = 'a11yfix_iframe_document_ready';

function getCurrentPagePostId() {
	const rawPostId = window?.a11yfixClientData?.postId;
	const parsedPostId = Number.parseInt(String(rawPostId), 10);

	if (!Number.isInteger(parsedPostId) || parsedPostId <= 0) {
		return null;
	}

	return parsedPostId;
}

function notifyIframePageReady() {
	if (!window.parent || window.parent === window) {
		return;
	}

	window.parent.postMessage(
		{
			type: A11YFIX_IFRAME_READY_MESSAGE,
			url: window.location.href,
			postId: getCurrentPagePostId()
		},
		window.location.origin
	);
}

if (document.readyState === 'complete') {
	notifyIframePageReady();
} else {
	window.addEventListener('load', () => {
		notifyIframePageReady();
	});
}
